// extracted by mini-css-extract-plugin
export default {"Container":"CompleteRegistration_Container__yuNgj"};